module.exports = __webpack_public_path__ + "static/media/s_v10_11_1.13b9cf02.mp3";